const pms_purchase_transaction_type = [
  {
    value: "reo",
    name: "REO",
  },
  {
    value: "standard_sale",
    name: "Standard Sale",
  },
  {
    value: "foreclosure",
    name: "Foreclosure",
  },
  {
    value: "trustee_sale",
    name: "Trustee Sale",
  },
  {
    value: "short_sale",
    name: "Short Sale",
  },
  {
    value: "probate_with_confirmation",
    name: "Probate with Confirmation",
  },
  {
    value: "probate",
    name: "Probate w/o Confirmation",
  },
];

export default pms_purchase_transaction_type;



// WEBPACK FOOTER //
// ./src/constants/pms_purchase_transaction_type.js